import React, { useState } from 'react';
import Sidebar from '../layout/Sidebar';
import NewProjectModal from '../tasks/NewProjectModal';
import TeamMemberModal from '../tasks/TeamMemberModal';
import EditProfileModal from '../tasks/EditProfileModal';
import DeleteConfirmModal from '../tasks/DeleteConfirmModal';



const Field = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#89A8B1', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 3 }}>{label}</div>
      <div style={{ fontSize: 14, color: '#071D39', fontWeight: 500 }}>{value}</div>
    </div>
  );
};

const ReadOnlyDealView = ({ project, onClose, onRestore, onDelete }) => {
  const agentLabel = project.type === 'Seller' ? "Buyer's Agent" : "Seller's Agent";
  const formatMoney = (val) => val ? `$${Number(val).toLocaleString()}` : null;
  const formatPercent = (val) => val ? `${val}%` : null;

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 100, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div style={{ width: '100%', maxWidth: 800, backgroundColor: '#f4f5f7', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>

        {/* Header */}
        <div style={{ backgroundColor: '#516469', padding: '20px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.08em', marginBottom: 4 }}>ARCHIVED DEAL — READ ONLY</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#FFFFFF' }}>{project.propertyAddress || project.clientName || 'Archived Deal'}</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginTop: 2 }}>Client: {project.clientName} · {project.type}</div>
          </div>
          <button onClick={onClose} style={{ backgroundColor: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '8px 16px', color: '#FFFFFF', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>✕ Close</button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px 28px', flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 32px' }}>

          {/* Deal Info */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#75BB2E', letterSpacing: '0.08em', textTransform: 'uppercase', borderBottom: '1px solid #d0d4da', paddingBottom: 8, marginBottom: 16 }}>Deal Info</div>
            <Field label="Property Address" value={project.propertyAddress} />
            <Field label="Client" value={project.clientName} />
            <Field label="Type" value={project.type} />
            <Field label="Primary Agent" value={project.primaryAgent} />
            <Field label="Phone" value={project.phone} />
            <Field label="Email" value={project.email} />
          </div>

          {/* Key Dates */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#75BB2E', letterSpacing: '0.08em', textTransform: 'uppercase', borderBottom: '1px solid #d0d4da', paddingBottom: 8, marginBottom: 16 }}>Key Dates</div>
            <Field label="Listing Date" value={project.listingDate} />
            <Field label="Under Contract Date" value={project.ucDate} />
            <Field label="Closing Date" value={project.closingDate} />
          </div>

          {/* Opposing Agent */}
          {project.opposingAgentName && (
            <div style={{ gridColumn: '1 / -1', marginTop: 8 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#75BB2E', letterSpacing: '0.08em', textTransform: 'uppercase', borderBottom: '1px solid #d0d4da', paddingBottom: 8, marginBottom: 16 }}>{agentLabel}</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 32px' }}>
                <Field label="Name" value={project.opposingAgentName} />
                <Field label="Phone" value={project.opposingAgentPhone} />
                <Field label="Email" value={project.opposingAgentEmail} />
              </div>
            </div>
          )}

          {/* Financials */}
          <div style={{ gridColumn: '1 / -1', marginTop: 8 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#75BB2E', letterSpacing: '0.08em', textTransform: 'uppercase', borderBottom: '1px solid #d0d4da', paddingBottom: 8, marginBottom: 16 }}>Financials</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 32px' }}>
              <Field label="List Price" value={formatMoney(project.listPrice)} />
              <Field label="Contract Price" value={formatMoney(project.contractPrice)} />
              <Field label="Commission" value={formatPercent(project.commissionPercent)} />
              <Field label="Broker Split" value={project.brokerSplitValue ? `${project.brokerSplitValue}${project.brokerSplitType === 'percent' ? '%' : ' (flat)'}` : null} />
              <Field label="Transaction Fee" value={formatMoney(project.transactionFee)} />
              <Field label="TC Fee" value={formatMoney(project.tcFee)} />
            </div>
          </div>

        </div>

        {/* Footer actions */}
        <div style={{ padding: '16px 28px', backgroundColor: '#FFFFFF', borderTop: '1px solid #d0d4da', display: 'flex', gap: 10, flexShrink: 0 }}>
          <button onClick={onRestore} style={{ backgroundColor: '#071D39', color: '#FFFFFF', border: 'none', borderRadius: 8, padding: '10px 20px', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Restore to Active</button>
          <button onClick={onDelete} style={{ backgroundColor: '#FEE2E2', color: '#DC2626', border: '1px solid #FCA5A5', borderRadius: 8, padding: '10px 20px', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Delete Deal</button>
          <button onClick={onClose} style={{ backgroundColor: 'transparent', color: '#516469', border: '1px solid #d0d4da', borderRadius: 8, padding: '10px 20px', fontWeight: 600, fontSize: 13, cursor: 'pointer', marginLeft: 'auto' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

const ArchiveView = ({
  activeProjects, archivedProjects, teamMembers, currentView,
  onSelectProject, onPipeline, onDashboard, onArchive, onNewProject,
  onTeamSettings, onMyProfile, onLogout, getDealTitle, isAdmin,
  unarchiveProject, onDeleteDeal, isSuperAdmin, onSuperAdmin, onHelpSupport, user, orgId,
  showNewProjectModal, onCloseNewProject, createProject,
  showTeamModal, onCloseTeamModal, addTeamMember, removeTeamMember, onEditTeamMember,
  showDeleteModal, dealToDelete, onConfirmDelete, onCancelDelete,
  showEditProfileModal, editProfileMember, editProfileMode,
  onCloseEditProfile, onSaveEditProfile,
}) => {
  const [viewingDeal, setViewingDeal] = useState(null);

  return (
    <div className="flex h-screen" style={{ backgroundColor: '#FFFFFF' }}>
      <Sidebar
        projects={activeProjects}
        onSelectProject={onSelectProject}
        onPipeline={onPipeline}
        onDashboard={onDashboard}
        onArchive={onArchive}
        onNewProject={onNewProject}
        onTeamSettings={onTeamSettings}
        onMyProfile={onMyProfile}
        onLogout={onLogout}
        currentView={currentView}
        getDealTitle={getDealTitle}
        isAdmin={isAdmin}
        isSuperAdmin={isSuperAdmin}
        onSuperAdmin={onSuperAdmin}
        onHelpSupport={onHelpSupport}
        user={user}
        orgId={orgId}
      />
      <div className="flex-1 p-8 overflow-auto">
        <h1 className="text-3xl font-bold mb-6" style={{ color: '#071D39' }}>Deal Archive</h1>
        {archivedProjects.length === 0 ? (
          <p className="text-gray-500">No archived deals</p>
        ) : (
          <div className="flex flex-col gap-4 w-full">
            {archivedProjects.map((project) => (
              <div key={project.id} className="p-4 rounded-lg border-2 w-full"
                style={{ borderColor: '#89A8B1', backgroundColor: '#F5F5F5' }}>
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-bold text-lg mb-2" style={{ color: '#071D39' }}>
                      {project.propertyAddress}
                    </h3>
                    <p className="text-sm mb-1" style={{ color: '#516469' }}>Client: {project.clientName}</p>
                    <p className="text-sm mb-3" style={{ color: '#516469' }}>Type: {project.type}</p>
                  </div>
                  <button
                    onClick={() => onDeleteDeal(project)}
                    className="px-3 py-1 rounded font-semibold text-sm"
                    style={{ backgroundColor: '#FEE2E2', color: '#DC2626' }}>
                    Delete
                  </button>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={() => setViewingDeal(project)}
                    className="px-4 py-2 rounded font-semibold text-sm"
                    style={{ backgroundColor: '#071D39', color: '#FFFFFF' }}>
                    View Deal
                  </button>
                  <button
                    onClick={() => unarchiveProject(project.id)}
                    className="px-4 py-2 rounded font-semibold text-sm"
                    style={{ backgroundColor: '#516469', color: '#FFFFFF' }}>
                    Restore to Active
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {viewingDeal && (
        <ReadOnlyDealView
          project={viewingDeal}
          onClose={() => setViewingDeal(null)}
          onRestore={() => { unarchiveProject(viewingDeal.id); setViewingDeal(null); }}
          onDelete={() => { setViewingDeal(null); onDeleteDeal(viewingDeal); }}
        />
      )}
      {showNewProjectModal && (
        <NewProjectModal onClose={onCloseNewProject} onSave={createProject} teamMembers={teamMembers} />
      )}
      {showTeamModal && (
        <TeamMemberModal
          onClose={onCloseTeamModal} onAdd={addTeamMember}
          onRemove={removeTeamMember} onEdit={onEditTeamMember}
          teamMembers={teamMembers} isAdmin={isAdmin}
        />
      )}
      {showDeleteModal && dealToDelete && (
        <DeleteConfirmModal
          projectAddress={dealToDelete.propertyAddress}
          onConfirm={onConfirmDelete} onCancel={onCancelDelete}
        />
      )}
      {showEditProfileModal && editProfileMember && (
        <EditProfileModal
          member={editProfileMember} mode={editProfileMode}
          isAdmin={isAdmin} onClose={onCloseEditProfile} onSave={onSaveEditProfile}
        />
      )}
    </div>
  );
};

export default ArchiveView;
